import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

export function Loader() {
  const location = useLocation();

  // Get contextual message based on the current route
  const getMessage = () => {
    if (location.pathname === '/courses') {
      return 'Loading your available courses...';
    }
    if (location.pathname.match(/^\/courses\/\d+$/)) {
      return 'Loading your learning path...';
    }
    if (location.pathname.match(/^\/courses\/\d+\/levels\/\d+$/)) {
      return 'Getting everything ready...';
    }
    return 'Loading...';
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-bg-main/95 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center gap-8">
        {/* Logo with bounce animation */}
        <motion.div
          className="w-20 h-20 relative"
          animate={{
            y: [0, -15, 0],
            rotate: [0, 5, 0, -5, 0],
          }}
          transition={{
            y: { duration: 1.5, repeat: Infinity, ease: 'easeInOut' },
            rotate: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
          }}
        >
          <img
            src="/images/llaami.svg"
            alt="Llaami Logo"
            className="w-full h-full"
          />
        </motion.div>

        {/* Animated progress bar */}
        <div className="flex flex-col items-center gap-4">
          <motion.div
            className="h-1.5 w-56 bg-accent-purple/20 rounded-full overflow-hidden"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className="h-full bg-accent-purple rounded-full"
              animate={{
                x: ['-100%', '100%'],
                backgroundColor: ['#c8b5f6', '#facee5', '#f7914e', '#c8b5f6'],
              }}
              transition={{
                x: { duration: 1.5, repeat: Infinity, ease: 'easeInOut' },
                backgroundColor: { duration: 6, repeat: Infinity },
              }}
            />
          </motion.div>

          {/* Message with fade animation */}
          <motion.p
            className="text-center text-subheading font-medium"
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          >
            {getMessage()}
          </motion.p>
        </div>

        {/* Little decoration dots */}
        <div className="flex gap-3 mt-2">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              className="w-2 h-2 rounded-full bg-accent-pink"
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: i * 0.4,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
